import { TrackingEvent } from '../types';

// Please update `./README.md` when changing the tracking configuration!

export const clickedIntroSearchResult = (type: string, label: string, query: string): TrackingEvent[] => [
    {
        category: 'intro search',
        action: 'click - intro search result',
        name: `${type} - ${label}`,
    },
    {
        category: 'intro search',
        action: 'click - intro search result - query',
        name: query,
    },
];
